import { render, staticRenderFns } from "./AppealResponseModal.vue?vue&type=template&id=67a5fcd1"
import script from "./AppealResponseModal.vue?vue&type=script&lang=js"
export * from "./AppealResponseModal.vue?vue&type=script&lang=js"
import style0 from "./AppealResponseModal.vue?vue&type=style&index=0&id=67a5fcd1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports